<template lang="pug">
  #signUpSuccess.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      .pt-5
        img.pt-5.pb-3(
          :src='okImg',
          alt='success_ok_img',
          width="74"
        )
        p.font-weight-bold.mb-0 預約申請成功
        hr.border-primary.w-100
        small.d-block.mb-0.px-4 您已提出申請預約，請靜待專屬CA來電與您聯繫。
    button.btn.btn-block.btn-primary(
      type="button",
      @click="backToLINEHandler()"
    ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'reservationSuccess',
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
